import { render, staticRenderFns } from "./UserOptionActionColumn.vue?vue&type=template&id=004a04c2&scoped=true"
import script from "./UserOptionActionColumn.vue?vue&type=script&lang=ts"
export * from "./UserOptionActionColumn.vue?vue&type=script&lang=ts"
import style0 from "./UserOptionActionColumn.vue?vue&type=style&index=0&id=004a04c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a04c2",
  null
  
)

export default component.exports